import z from 'zod';

export const CreateReleaseSchema = z.object({
    title: z.string().min(1, 'Please provide a title'),
    cover_image: z.string().min(1, 'Please provide a cover image'),
})